import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'QUITUS_OPER',
  title: 'Was ist der Projekt Ordner?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Der Projekt Ordner ist die Zusammenfassung Ihrer Dokumente für ein bestimmtes Projekt. Er zeigt den Status der für dieses Projekt erforderlichen Dokumente an. Er ersetzt die zahlreichen obligatorischen Dokumente, die bei der Unterzeichnung vorzulegen sind, und vereinfacht Ihren Austausch mit Ihren Partnern. Sie können die für ein Projekt erforderlichen Dokumente einsehen. Dazu können Sie :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Auf die Registerkarte "Projekte" klicken'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_QUITUS_OPER/DE_QUITUS_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Auf die 3 Punkte oben rechts klicken'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_QUITUS_OPER/DE_QUITUS_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Dann klicken Sie auf "Angeforderte Dokumente anzeigen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_QUITUS_OPER/DE_QUITUS_OPER_3.png`
  }]
};
